var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { apiClient } from '@utils/apiClient';
export const userService = {
    getUsers() {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get('/users');
        });
    },
    getUserById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.get(`/users/${id}`);
        });
    },
    createUser(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.post('/users', data);
        });
    },
    updateUser(id, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.put(`/users/${id}`, data);
        });
    },
    deleteUser(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.delete(`/users/${id}`);
        });
    },
    updateUserRoles(id, roles) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.put(`/users/${id}/roles`, { roles });
        });
    },
    adminChangePassword(id, newPassword) {
        return __awaiter(this, void 0, void 0, function* () {
            return apiClient.post(`/users/${id}/change-password`, { newPassword });
        });
    },
};
